import gql from "graphql-tag";
import { orderUnitSettingsDispaySettingFragments, orderPartyFragments, orderDeliveryFragments, orderLineFragments, orderAllowanceChargeFragments, orderCustomerFragments } from "./Order";

export const recurringOrderFragments = gql`
  fragment recurringOrderFragments on RecurringOrder {
    id
    unit {
      id
      name
      isCompany
      ...orderUnitSettingsDispaySettingFragments
    }
    currencyCode
    logo {
      id
      signedBlobId
      url(size: LARGE)
    }
    reference
    export
    currencyCode
    taxAmount
    lineExtensionAmount
    taxExclusiveAmount
    taxInclusiveAmount
    payableAmount
    customer {
      ...orderCustomerFragments
    }
    bban
    iban
    note
    project {
      id
      code
      name
    }
    department {
      id
      code
      name
    }
    car {
      id
      name
      registrationNumber
    }
    supplierParty {
      ...orderPartyFragments
    }
    customerParty {
      ...orderPartyFragments
    }
    orderDelivery {
      ...orderDeliveryFragments
    }
    orderLines {
      ...orderLineFragments
    }
    orderAllowanceCharges {
      ...orderAllowanceChargeFragments
    }
    recurringOrderSetting {
      id
      active
      startDate
      endDate
      dateOffset
      interval
      lastDateCreatedOn
    }
  }
  ${orderUnitSettingsDispaySettingFragments}
  ${orderCustomerFragments}
  ${orderPartyFragments}
  ${orderDeliveryFragments}
  ${orderLineFragments}
  ${orderAllowanceChargeFragments}
`;
